'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Button = require('@narvar/nth-block-button');
var Box = require('../../../../../../../common/components/layout/Box/Box.js');
var Typography = require('../../../../../../../common/components/Typography.js');
var OTPProvider = require('../OTPProvider.js');
var RadioCard = require('../../../../../../../common/components/RadioCard/RadioCard.js');
var useTitanAnalytics = require('../../../../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const OTPSkip = () => {
  const titan = useTitanAnalytics["default"]();
  const {
    claimsOtpSkipTitle,
    claimsOtpSkipSubmit
  } = nthHookTranslations.useTranslations();
  const {
    otpSkipReasons,
    otpSkip
  } = OTPProvider.useOTP();
  const [reason, setReason] = React.useState('');
  const submitDisabled = !reason;
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.page({
      name: 'OTP Skip'
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, {
    as: "h1"
  }, claimsOtpSkipTitle), /*#__PURE__*/React__default["default"].createElement("form", {
    noValidate: true,
    onSubmit: e => {
      e.preventDefault();
      otpSkip(reason);
    }
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, otpSkipReasons.map(_ref => {
    let {
      value,
      text
    } = _ref;
    return /*#__PURE__*/React__default["default"].createElement(RadioCard["default"], {
      key: value,
      id: value,
      value: value,
      name: "otpSkipReason",
      selected: value === reason,
      onChange: () => setReason(value)
    }, /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, text));
  }), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    type: Button.ButtonType.submit,
    big: true,
    disabled: submitDisabled
  }, claimsOtpSkipSubmit))));
};
var OTPSkip$1 = nthHookTranslations.withTranslationsProvider(OTPSkip, {
  translationKeys: ['claimsOtpSkipTitle', 'claimsOtpSkipSubmit']
});

exports["default"] = OTPSkip$1;
